window.countdownTimers = {};

import 'owl.carousel';

require('bootstrap-pincode-input');

$(document).ready(function () {

    $('.dark-mode-toggle').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('body').css('transition', 'all 400ms ease-in-out');

        setTimeout(function () {
            $('body').toggleClass('dark-mode');

        }, 100)

        setTimeout(function () {
            $('body').css('transition', 'unset');
            saveDarkMode();
        }, 500)

    })

    $('.google-pin').pincodeInput({inputs: 6, hidedigits: false});

    dayjs.tz.setDefault(window.tz);

    $.fn.isOnScreen = function () {
        let win         = $(window);
        let viewport    = {
            top : win.scrollTop(),
            left: win.scrollLeft()
        };
        viewport.right  = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height() - 32;
        let bounds      = this.offset();
        bounds.right    = bounds.left + this.outerWidth();
        bounds.bottom   = bounds.top + this.outerHeight() - 32;
        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    $('.current-time').html(dayjs().format('YYYY-MM-DD HH:mm:ss'));

    $('.owl-carousel').owlCarousel({
                                       loop              : true,
                                       nav               : true,
                                       items             : 1,
                                       navContainer      : '.own-arrows',
                                       dotsContainer     : '.own-dots',
                                       autoplay          : true,
                                       autoplayTimeout   : 4000,
                                       autoplayHoverPause: true
                                   });

    $('.rating-carousel').owlCarousel({
                                          loop           : true,
                                          nav            : false,
                                          items          : 1,
                                          dotsContainer  : '.own-dots',
                                          margin         : 0,
                                          autoplay       : true,
                                          autoplayTimeout: 3000,
                                          responsive     : {
                                              576: {
                                                  items : 2,
                                                  margin: 32
                                              },
                                              777: {
                                                  items : 3,
                                                  margin: 65
                                              }
                                          }
                                      });


    $('.local-timer').each(function () {
        var $this   = $(this);
        var timerId = Math.random();
        $this.data('timer', timerId);
        var countdownTo = $this.data('countdown-to');

        // console.log(countdownTo);

        if (countdownTimers.hasOwnProperty(timerId)) {
            clearInterval(countdownTimers[timerId]);
        }
        countdownTimers[timerId] = setInterval(
            function () {
                let run = $this.data('countdown-end-run');
                // let timeLeft     = dayjs.duration(dayjs.unix(countdownTo).diff(dayjs()));
                // var timeLeftText = 'Hours: ' + dayjs.utc(timeLeft.asMilliseconds()).format('DD');
                // timeLeftText += 'Hours: ' + dayjs.utc(timeLeft.asMilliseconds()).format('HH');
                // timeLeftText += 'Minutes: ' + dayjs.utc(timeLeft.asMilliseconds()).format('mm');
                // timeLeftText += 'Seconds: ' + dayjs.utc(timeLeft.asMilliseconds()).format('ss');

                let timeLeft = dayjs.duration(dayjs.unix(countdownTo).diff(dayjs()));
                var timeLeftText = 'Days: ' + timeLeft.days();
                timeLeftText += ' Hours: ' + timeLeft.hours();
                timeLeftText += ' Minutes: ' + timeLeft.minutes();
                timeLeftText += ' Seconds: ' + timeLeft.seconds();

                if (dayjs.unix(countdownTo).isBefore(dayjs())) {
                    // console.log(dayjs.unix(countdownTo).format('YYYY-MM-DD HH:mm:ss') + ' JE SKOR AKO ' + dayjs().format('YYYY-MM-DD HH:mm:ss'));
                    $this.text('00:00');
                    clearInterval(countdownTimers[timerId]);
                    if (typeof run !== 'undefined') {
                        eval(run);
                    }
                } else {
                    $this.text(timeLeftText)
                }
            },
            1000
        );
    });
})

window.addDivLoadSpinner = function (el) {
    // debugger;
    if (el.length > 0) {
        if ($("#divl_" + el[0].id).length > 0) {
            $("#divl_" + el[0].id).css('display', 'block');
        } else {
            var div = $('<div class="divl_wrap"></div>')
            div.attr('id', "divl_" + el[0].id);

            var img = $('<img class="s2l_img">');
            img.attr('id', "s2l_img_" + el[0].id);
            img.attr('src', '/assets/img/icon-loading-200-nobg.gif');
            var span = $('<span class="s2l_span">Loading</span>');
            div.append(img);
            div.append(span);
            div.prependTo(el[0]);
        }
        el.prop("disabled", true);
    }
}

window.hideDivLoadSpinner = function (el) {
    if (el.length > 0) {
        if ($("#divl_" + el[0].id).length > 0) {
            setTimeout(function () {
                           $("#divl_" + el[0].id).css('display', 'none');
                           el.prop("disabled", false);
                       },
                       500);
        }
    }
}

window.addS2LoadSpinner = function (el) {
    // debugger;
    if (el.length > 0) {
        if ($("#img_" + el[0].id).length > 0) {
            $("#img_" + el[0].id).css('display', 'block');
        } else {
            var div = $('<div class="s2l_wrap"></div>')
            div.attr('id', "s2l_div_" + el[0].id);

            var img = $('<img class="s2l_img">');
            img.attr('id', "s2l_img_" + el[0].id);
            img.attr('src', '/assets/img/icon-loading-200-nobg.gif');
            var span = $('<span class="s2l_span">Loading</span>');
            div.append(img);
            div.append(span);
            div.prependTo(el[0].nextElementSibling);
        }
        el.prop("disabled", true);
    }
}

window.hideS2LoadSpinner = function (el) {
    if (el.length > 0) {
        if ($("#s2l_div_" + el[0].id).length > 0) {
            setTimeout(function () {
                           $("#s2l_div_" + el[0].id).css('display', 'none');
                           el.prop("disabled", false);
                       },
                       500);
        }
    }
}

window.copyToClipboard = function (elem) {
    // create hidden text element, if it doesn't already exist
    const targetId = "_hiddenCopyText_";
    const isInput  = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    let origSelectionStart, origSelectionEnd;
    let target;
    if (isInput) {
        // can just use the original source element for the selection and copy
        target             = elem;
        origSelectionStart = elem.selectionStart;
        origSelectionEnd   = elem.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            target                = document.createElement("textarea");
            target.style.position = "absolute";
            target.style.left     = "-9999px";
            target.style.top      = "0";
            target.id             = targetId;
            document.body.appendChild(target);
        }
        target.textContent = elem.textContent;
    }
    // select the content
    let currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    let succeed;
    try {
        succeed = document.execCommand("copy");
    } catch (e) {
        succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }

    if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = "";
    }
    return succeed;
}

function saveDarkMode() {
    $.ajax({
               type   : 'POST',
               url    : '/ajax/self/theme',
               data   : {dark: $('body').hasClass('dark-mode')},
               success: function (data) {
                   //console.log("Success!", data);
               }
           });
}
